import { useEffect, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

//Componentes
import SectionTitle from '../../SectionTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '../../Alert';

// Queries
import getBranchSolicitar from '../../Queries/getBranchSolicitar';
import getCookie from '../../Queries/getCookie';

// Styles
import styles from './index.module.sass';

export default function Petition({ setSessionMessage, device }) {
  const [monthsRequest, setMonthsRequest] = useState([]);
  const [monthsInactive, setMonthsInactive] = useState([]);
  const [requestSelected, setRequestSelected] = useState('');
  const [inactiveSelected, setInactiveSelected] = useState('');
  const [requestLoading, setRequestLoading] = useState(false);
  const [inactiveLoading, setInactiveLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertText, setAlertText] = useState('');

  const { t } = useTranslation('petitions');
  const { screenSize } = device;

  const getRequest = useCallback(
    async ({ accion, anioMes, type, first }) => {
      setRequestLoading(true);
      const response = await getBranchSolicitar({
        jsonBody: {
          accion,
          usuarioOK: getCookie('usuarioOk'),
          idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
          anioMes,
        },
        type,
      });

      const { anioMes01 = '', anioMes02 = '', mensaje = '', tipoMensaje = 'error' } = response;

      setSessionMessage(mensaje);

      setMonthsRequest([anioMes01, anioMes02]);

      setRequestLoading(false);

      if (!first) {
        if (tipoMensaje === 'exito') setAlertText(t('sent'));
        else setAlertText(mensaje);
        setAlertOpen(true);
      }
    },
    [setSessionMessage, t],
  );

  const getInactiveRequest = useCallback(
    async ({ accion, anioMes, type, first }) => {
      setInactiveLoading(true);
      const response = await getBranchSolicitar({
        jsonBody: {
          accion,
          usuarioOK: getCookie('usuarioOk'),
          idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
          anioMes,
        },
        type,
      });

      const { anioMes01 = '', anioMes02 = '', mensaje = '', tipoMensaje = 'error' } = response;

      setMonthsInactive([anioMes01, anioMes02]);

      setSessionMessage(mensaje);

      setInactiveLoading(false);

      if (!first) {
        if (tipoMensaje === 'exito') setAlertText(t('sent'));
        else setAlertText(mensaje);
        setAlertOpen(true);
      }
    },
    [setSessionMessage, t],
  );

  useEffect(() => {
    getRequest({ accion: '', anioMes: '', type: '', first: true });
    getInactiveRequest({ accion: '', anioMes: '', type: 'inactive', first: true });
  }, [getRequest, getInactiveRequest]);

  function handleChange(e) {
    const value = e.target.value;
    if (e.target.name === 'invalid') setInactiveSelected(value);
    else setRequestSelected(value);
  }

  function handleRequest(type) {
    if (type === 'inactive')
      getInactiveRequest({ accion: 'CONTINUAR', anioMes: inactiveSelected, type: 'inactive' });
    else getRequest({ accion: 'CONTINUAR', anioMes: requestSelected, type: '' });
  }

  return (
    <div className={`${styles.Petition} ${styles[screenSize]}`}>
      <Alert open={alertOpen} setOpen={setAlertOpen} title={'Terramar'} text={alertText} />
      <SectionTitle title={t('petitionsTitle')} subtitle={t('petitionsSubtitle')} />
      <div className={styles.container}>
        <div className={styles.requestContainer}>
          <div className={styles.request}>
            <div className={styles.pettitionTitle}>{t('branch')}</div>
            <div className={styles.label}>{t('select')}</div>
            <div className={styles.actions}>
              <div className={styles.selectdiv}>
                <select
                  className={styles.inputText}
                  value={requestSelected}
                  name='request'
                  onChange={(e) => handleChange(e)}>
                  <option value=''>{t('option')}</option>
                  {monthsRequest.map((val, key) => {
                    return (
                      <option key={key} value={val}>
                        {val}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className={styles.buttonContainer}>
                <div
                  className={styles.button}
                  onClick={() => {
                    if (!requestLoading) handleRequest('request');
                  }}>
                  {(requestLoading && <CircularProgress className={styles.circularProgress} />) ||
                    t('textButton')}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.requestContainer}>
          <div className={styles.request}>
            <div className={styles.pettitionTitle}>{t('inactive')}</div>
            <div className={styles.label}>{t('select')}</div>
            <div className={styles.actions}>
              <div className={styles.selectdiv}>
                <select
                  className={styles.inputText}
                  value={inactiveSelected}
                  name='invalid'
                  onChange={(e) => {
                    if (!inactiveLoading) handleChange(e);
                  }}>
                  <option value=''>{t('option')}</option>
                  {monthsInactive.map((val, key) => {
                    return (
                      <option key={key} value={val}>
                        {val}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className={styles.buttonContainer}>
                <div
                  className={styles.button}
                  onClick={() => {
                    if (!requestLoading) handleRequest('inactive');
                  }}>
                  {(inactiveLoading && <CircularProgress className={styles.circularProgress} />) ||
                    t('textButton')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
